import React, { useState } from 'react';
import PropTypes from "prop-types";
import FormErrorList from "../../../../Components/Forms/FormErrorList";
import { validateTimeRange } from "../Validation/AvailabilityValidationSchema";

const TimeslotsInput = (props) => {

    const [fieldValue, setFieldValue] = useState('');
    const [localErrors, setLocalErrors] = useState({})

    const handleSlotChange = (updatedSlot) => {
        let updatedSlots = (props.slotValues) ? [...props.slotValues] : [];

        updatedSlots = [
            ...updatedSlots,
            ...updatedSlot.split(',')
                .map(slot => slot.trim())
                .filter(slot => slot)
        ].sort();

        let updatedErrors = validateTimeRange({
            [props.dateIndex]: updatedSlots
        });

        if (Object.values(updatedErrors).length === 0) {
            handleChange(updatedSlots);
        } else {
            setLocalErrors(updatedErrors);
            setFieldValue(updatedSlot);
        }
    }

    const handleChange = (updatedSlots) => {
        props.onChange(props.dateIndex, updatedSlots);
        setLocalErrors([]);
        setFieldValue('');
    }

    const handleRemoveSlot = (slot) => {
        let daySlots;
        if (props.slotValues) {
            daySlots = props.slotValues.filter(current => !_.isEqual(slot, current));
        } else {
            daySlots = [];
        }

        props.onChange(props.dateIndex, daySlots);
    }

    return (
        <div className="amenity-availability-input">
            { props.slotValues.map(slot => (
                <div
                    key={slot}
                    className="availability-slot"
                >
                    {slot}
                    <button
                        type="button"
                        onClick={e => handleRemoveSlot(slot)}
                    >
                        <i className="fa fa-times" />
                    </button>
                </div>
            ))}

            {(props.message) && (
                <div>{props.message}</div>
            )}

            <textarea
                name={props.dateIndex}
                value={fieldValue}
                onChange={e => handleSlotChange(e.target.value)}
                placeholder={props.placeholder}
            />

            {(localErrors) &&
                <ul className="calendar-errors">
                    <FormErrorList errors={localErrors}/>
                </ul>
            }
        </div>
    );
};

TimeslotsInput.propTypes = {
    dateIndex: PropTypes.string,
    slotValues: PropTypes.array,
    message: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
};

TimeslotsInput.defaultProps = {
    placeholder: ''
};

export default TimeslotsInput;
